import { createPortal } from 'react-dom';
import React, { useContext, useState, Fragment, useEffect, useRef } from 'react';
import {
  withStyles,
  Grid,
  Drawer,
  Divider,
  Dialog,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import DataContext from '../data/DataContext';
import Close from '../../asset/img/icon_close.svg';
import Error from '../../asset/img/icon_error.svg';
import CheckOn from '../../asset/img/icon_checkbox_on.svg';
import CheckOff from '../../asset/img/icon_checkbox_off.svg';
import ArrowDown from '../../asset/img/icon_arrow_down.svg';
import Terms3 from './Terms3';
import { useForm } from 'react-hook-form';
const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  drawerFrame: {
    borderRadius: '0',
    borderBottomRightRadius: '0',
    borderBottomLeftRadius: '0',
    height: '100%',
    overflowY: 'auto',
    transform: 'none',
    transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1)',
    position: 'fixed',
    zIndex: '1300',
    inset: '0',
    background: '#fff',
  },
  drawerRoot: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  dividerTitle: {
    height: '0.0625rem',
    background: '#000',
    margin: '0rem 0.875rem 1.2188rem 0.875rem',
  },
  titleClose: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    padding: '0.0625rem 0rem',
  },
  btnClose: {
    border: 'none',
    background: 'none',
  },
  close: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '1.5rem',
      height: '1.5rem',
      cursor: 'pointer',
    },
  },
  drawerHeaderClose: {
    position: 'fixed',
    height: '4.375rem',
    background: '#fff',
    width: '100%',
    zIndex: '1',
  },
  closeContainer: {
    display: 'flex',
    minHeight: 'auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.625rem 1rem',
  },
  componentWrapper: {
    overflowY: 'auto',
    paddingTop: '4.375rem',
  },
  loading: {
    zIndex: '2000',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#ffffffd9',
  },
  loadComplete: {
    display: 'none',
  },
  dialogRoot: {
    borderRadius: '0.625rem',
    width: '90%',
    maxWidth: '37.5rem',
  },
  dialogContent: {
    fontFamily: 'inherit',
    fontSize: theme.font.size16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.38',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
    padding: '2.5rem 1.25rem 0.9375rem !important',
  },
  dialogFooter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'cneter',
    padding: '0.9375rem',
    '& button': {
      height: '3.125rem',
      width: '50%',
      borderRadius: '0.375rem',
      border: 'solid 0.0625rem #ea1917', //"solid 0.0625rem #da0f47",
      fontFamily: 'inherit',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.43',
      letterSpacing: 'normal',
      textAlign: 'center',
    },
  },
  dialogFooterBtnLeft: {
    background: '#fff',
    color: '#000',
    border: 'solid 0.0625rem #ddd !important',
  },
  dialogFooterBtnRight: {
    background: '#ea1917', //"#da0f47",
    color: '#fff',
  },
  modalFooter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: ' 0.875rem 1rem',
    marginTop: '1rem',
    placeContent: 'center',
    borderTop: '0.0625rem solid #ddd',
  },
  modalButton: {
    width: '100%',
    height: '3.125rem',
    borderRadius: '0.375rem',
    border: 'solid 0.0625rem #ddd',
    backgroundColor: '#fff',
    fontFamily: 'NotoSansKR',
    fontSize: '0.875rem',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalButtonDefault: {
    color: '#bbb',
    backgroundColor: '#999',
    border: '0rem',
  },
  modalButtonStrong: {
    color: '#fff',
    backgroundColor: '#ea1917', //"#da0f47",
    border: '0rem',
    fontWeight: 'bold',
  },
  modalButtonLeft: {
    paddingRight: '0.25rem',
  },
  modalButtonRight: {
    paddingLeft: '0.25rem',
  },
  modalGridContainer: {},
  modalGridItemLabel: {
    padding: '0.3125rem 1rem 0rem 1rem',
  },
  modalGridItemLabelFirst: {
    padding: '0.25rem 1rem 0rem 1rem',
  },
  modalGridItem: {
    padding: '0.75rem 1rem',
  },
  modalLabel: {
    // minHeight: "1.25rem",
    display: 'flex',
    fontFamily: 'NotoSansKR',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    '& .star': {
      fontSize: theme.font.size14,
      color: '#ea1917', //"#da0f47"
    },
  },
  modalField: {
    // paddingTop: "0.75rem",
    '& input': {
      borderRadius: '0.375rem',
      width: '100%',
      height: '2.875rem',
      border: 'solid 0.0625rem #929292',
      padding: '0.8125rem 1rem',
    },
  },
  modalPlainBtn: {
    minHeight: '2.875rem',
    borderRadius: '0.375rem',
    border: 'solid 0.0625rem #000',
    backgroundColor: '#fff',
    width: '100%',
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalInnerItem: {
    padding: '0rem',
    paddingRight: '0.5rem',
  },
  modalInnerItemLast: {
    paddingRight: '0rem',
  },
  infoIcon: {
    width: '1rem',
    height: '1rem',
  },
  textareaField: {
    position: 'relative',
  },
  textarea: {
    width: '100%',
    height: '9.375rem',
    borderRadius: '0.375rem',
    background: '#fff',
    font: 'inherit',
    fontSize: '0.875rem',
    padding: '0.8125rem 1rem 2.1875rem',
  },
  textCount: {
    font: 'inherit',
    fontSize: '0.75rem',
    letterSpacing: 'normal',
    position: 'absolute',
    bottom: '0.875rem',
    right: '1rem',
  },
  nextLine: {
    paddingBottom: 0,
  },
  disabled: {
    background: '#ededed',
    border: '0rem !important',
  },
  showAll: {
    fontWeight: 'bold',
    fontSize: theme.font.size12,
    letterSpacing: 'normal',
    textDecoration: 'underline',
    // cursor: 'pointer',
    background: 'none',
    border: 'none',
    color: '#000',
  },
  terms: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  termTextArea: {
    height: '7.5rem',
    border: '0.0625rem solid #929292',
    borderRadius: '0.375rem 0.375rem 0 0',
    fontSize: theme.font.size12,
    padding: '1rem',
    lineHeight: '1.72',
    '& .termsDl': {
      height: '5.45rem',
      overflow: 'auto',
    },
    '& dl': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& p': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& dd': {
      marginInlineStart: '0rem',
    },
    '& ol': {
      listStyleType: 'none',
      paddingInlineStart: '0rem',
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
    '& li': {
      listStyleType: 'none',
      paddingInlineStart: '0',
    },
    '& ol.termsOl>li': {
      paddingBlockStart: '0.5rem',
      '&:first-child': {
        paddingBlockStart: '0rem',
      },
    },
    '& ul': {
      paddingInlineStart: '0.625rem',
    },
    '& dt': {
      fontWeight: 'bold',
    },
    '& .layerPopupTop': {
      display: 'none',
    },
    '& .type2.contentsLyrPopx': {
      display: 'none',
    },
    '& .layerTopBtn': {
      display: 'none',
    },
    '& .termsDl .blind': {
      display: 'none',
    },
    '& .layerPopupBottom': {
      display: 'none',
    },
  },
  termTextContent: {
    height: '5.45rem',
    overflowY: 'scroll',
  },
  checkArea: {
    height: '3rem',
    border: '0.0625rem solid #929292',
    borderTop: 'none',
    borderRadius: '0 0 0.375rem 0.375rem',
    fontSize: theme.font.size12,
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    '& input+label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      background: `url(${CheckOff}) no-repeat`,
      paddingLeft: '1.875rem',
      padding: '0.25rem 0rem 0.25rem 1.875rem',
    },
    '& input:checked + label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
      background: `url(${CheckOn}) no-repeat`,
      paddingLeft: '1.875rem',
      padding: '0.25rem 0rem 0.25rem 1.875rem',
    },
    '& input': {
      height: '1.25rem',
      width: '1.25rem',
      marginRight: '0.375rem !important',
      display: 'none',
    },
  },
  errorIcon: {
    width: '0.75rem',
    height: '0.75rem',
    color: '#ff3723',
    marginRight: '0.1875rem',
  },
  errorText: {
    color: '#ff3723',
    fontSize: theme.font.size13,
    display: 'flex',
    alignItems: 'center',
    paddingTop: '0.5rem',
  },
  select: {
    borderRadius: '0.375rem',
    border: 'solid 0.0625rem #929292',
    width: '100%',
    height: '2.875rem',
    '-moz-appearance': 'none',
    '-webkit-appearance': 'none',
    appearance: 'none',
    background: `url(${ArrowDown}) no-repeat right`,
    padding: '0rem 1rem',
    backgroundOrigin: 'content-box',
    border: '1px solid #929292',
    color: '#666',
    '&::placeholder': {
      color: theme.color.input.placeholder,
    },
  },
  selectSelected: {
    color: '#000',
  },
  input: {
    fontSize: theme.font.size14,
    '&::placeholder': {
      color: theme.color.input.placeholder,
    },
  },
  selectOption: {
    color: '#000',
  },
});
const Input = withStyles(styles)((props) => {
  const { classes, register, label, req, errors } = props;

  return (
    <Fragment>
      <input
        {...props}
        {...register(label, req)}
        className={[classes.error, classes.input].join(' ')}
      />
      {errors[label] && <ErrorMsg text={[errors[label].message]} />}
    </Fragment>
  );
});

const ErrorMsg = withStyles(styles)((props) => {
  const { classes, text } = props;
  return (
    <Fragment>
      <div className={classes.errorText}>
        <img src={Error} className={classes.errorIcon} alt="입력/수정 필요" />
        {text}
      </div>
    </Fragment>
  );
});

const CounselModal = withStyles(styles)((props) => {
  const { classes, modalClose, data, setCloseDialogOpen } = props;
  const context = useContext(DataContext);

  const [ageValue, setAgeValue] = useState('');
  const [username, setUsername] = useState(data.modal?.data?.user?.user_name || '');
  const [phonenum, setPhonenum] = useState(data.modal?.data?.user?.phone_number || '');

  const modalData = data.modal.data;
  const counselType = modalData.counsel_type;

  const [termText, setTermText] = useState('');

  useEffect(() => {
    (async () => {
      let response = await fetch('/ext/reservation/html/terms/terms_3_kr.html');
      let term_text = await response.text();
      setTermText(term_text);
    })();
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  let ageList = [
    { text: '20대 이하', value: '20' },
    { text: '30대~40대', value: '30' },
    { text: '50대~60대', value: '50' },
    { text: '70대 이상', value: '70' },
  ];

  const ageChangeHandler = (event) => {
    const selectedValue = event.currentTarget.value;
    console.log(selectedValue);
    setAgeValue(selectedValue);
  };

  const usernameHandler = (event) => {
    const tempUsername = event.target.value;
    console.log(tempUsername);
    setUsername(tempUsername);
  };

  const phonenumHandler = (event) => {
    const tempPhonenum = event.target.value;
    console.log(tempPhonenum);
    setPhonenum(tempPhonenum);
  };

  const handleClickConfirm = () => {
    let dataParameters = data?.parameters;
    let dataExpect = data?.expect || {
      mode: 'bypass',
      intent:
        counselType === 'purchase'
          ? 'THQ_PURCHASE_EXPERT_CHAT'
          : 'THQ_CUSTOMER_SERVICE_CHAT',
    };
    let parameters = {
      ...dataParameters,
      user_name: username,
      phone_number: phonenum,
      bypass_br: 'counsel',
    };
    if (counselType === 'customer') {
      parameters['age_group'] = ageValue;
    }
    context.request(
      context,
      dataParameters?.speech || '확인',
      'button',
      parameters,
      dataExpect
    );
    modalClose();
  };
  const [termModalOpen, setTermModalOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const handleCheckClick = () => {
    setChecked((prev) => !prev);
    // dispatch()
  };
  const dispatch = () => {
    console.log('dispathch....');
    var input = document.querySelector('input[name="checkHidden"]');
    const event = new Event('input', { bubbles: true });
    const tracker = input._valueTracker;
    if (tracker) {
      tracker.setValue('');
    }
    input.dispatchEvent(event);
  };

  const phoneValidator = (telNum) => {
    var ment = '';
    var tel1 = '';
    var tel2 = '';
    var tel3 = '';
    var tel2_ = '';
    var result = '휴대전화 번호를 정확히 입력해 주세요';

    try {
      tel1 = telNum.substr(0, 3);
      tel2 = telNum.length === 10 ? telNum.substr(3, 3) : telNum.substr(3, 4);
      tel3 = telNum.substr(telNum.length - 4, 4);
      tel2_ = telNum.substr(3, 1);

      if (
        (tel1 === '011' ||
          tel1 === '016' ||
          tel1 === '017' ||
          tel1 === '018' ||
          tel1 === '019') &&
        tel2.length === 3
      ) {
        if (tel2 >= 200 && tel2 <= 899) {
          //return true;
        } else {
          ment =
            '국번 번호는 "200~899" 만 허용하며, "000~199", "900~999" 허용 불가합니다.';
        }
      }
      if (ment === '') {
        switch (tel1) {
          case '010':
            if (tel2_ === '0' || tel2_ === '1') {
              ment = '국번 번호의 첫자리가 "0, 1"은 잘못된 국번입니다.';
            } else {
              /*return true;*/
            }
            break;
          case '011':
            if (tel2.length === 4) {
              if ((tel2 >= 1700 && tel2 <= 1799) || (tel2 >= 9500 && tel2 <= 9999)) {
                //return true;
              } else {
                ment =
                  '국번 번호 범위가 맞지 않습니다. "011" 이면 "1700~1799" 또는 "9500~9999" 만 허용합니다.';
              }
            } else if (tel2.length === 3) {
              if (tel2 >= 200 && tel2 <= 899) {
                //return true;
              } else {
                ment =
                  '국번 번호 범위가 맞지 않습니다. "011" 이면 "200~899" 만 허용합니다.';
              }
            }
            break;
          case '016':
          case '019':
            if ((tel2 >= 200 && tel2 <= 899) || (tel2 >= 9000 && tel2 <= 9999)) {
              //return true;
            } else {
              ment =
                '국번 번호 범위가 맞지 않습니다. "016, 019" 이면 "9000~9999" 까지만 허용합니다.';
            }
            break;
          case '017':
          case '018':
            if (tel2.length === 4) {
              ment = '"017, 018"의 경우 국번은 4자리이면 안됩니다.';
            } else {
              if (tel2 >= 200 && tel2 <= 899) {
                //return true;
              } else {
                ment =
                  '국번 번호 범위가 맞지 않습니다. "017, 018" 이면 "200~899" 까지만 허용합니다.';
              }
            }
            break;
          default:
            ment = '"010, 011, 016, 017, 018, 019" 만 허용합니다.';
            break;
        }
      }
      return ment === '' || result;
    } catch (er) {
      return result;
    } finally {
      console.log(
        '휴대폰번호 유효성 검사결과 : [tel1:' +
          tel1 +
          ', tel2:' +
          tel2 +
          ', tel3:' +
          tel3 +
          ', tel2_:' +
          tel2_ +
          ']' +
          ment
      );
    }
  };

  return (
    <Fragment>
      <form onSubmit={handleSubmit(handleClickConfirm)}>
        <Grid container className={classes.modalGridContainer}>
          {/* 이름 */}
          <Grid
            item
            xs={12}
            className={[classes.modalGridItemLabel, classes.modalGridItemLabelFirst].join(
              ' '
            )}
          >
            <div className={classes.modalLabel}>
              이름<span className="star">*</span>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={classes.modalField}>
              <Input
                label="user_name"
                register={register}
                errors={errors}
                req={{
                  required: '이름을 입력해주세요.',
                  minLength: { value: 1, message: '이름을 입력해주세요.' },
                  maxLength: { value: 25, message: '최대 입력 길이를 초과하였습니다.' },
                  pattern: {
                    value: /^[ㄱ-ㅎ가-힣a-zA-Z|]+$/gi,
                    message: '이름은 한글, 영문만 가능합니다.',
                  },
                  onChange: usernameHandler,
                  disabled: data.modal?.data?.user?.user_name ? true : false,
                }}
                placeholder="이름을 입력해주세요."
                type="text"
                maxLength="25"
                value={username}
              />
            </div>
          </Grid>
          {/* 휴대전화번호 */}
          <Grid item xs={12} className={classes.modalGridItemLabel}>
            <div className={classes.modalLabel}>
              휴대전화번호<span className="star">*</span>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.modalGridItem}>
            <div className={classes.modalField}>
              <Input
                label="phone_number"
                register={register}
                errors={errors}
                req={{
                  required: '휴대전화 번호를 입력해 주세요.',
                  minLength: {
                    value: 10,
                    message: '휴대전화 번호를 정확히 입력해 주세요.',
                  },
                  maxLength: {
                    value: 11,
                    message: '휴대전화 번호를 정확히 입력해 주세요.',
                  },
                  // pattern: {value:/^[0-9]*$/gi, message:'숫자만 입력 가능합니다.'},
                  pattern: {
                    value: /^(?:(010\d{4})|(01[1|6|7|8|9]\d{3,4}))(\d{4})$/gi,
                    message: '휴대전화 번호를 정확히 입력해 주세요.',
                  },
                  validate: { phoneValidator },
                  onChange: phonenumHandler,
                  disabled: data.modal?.data?.user?.phone_number ? true : false,
                }}
                value={phonenum}
                placeholder="휴대전화 번호를 입력해 주세요."
                type="tel"
                maxLength="11"
              />
            </div>
          </Grid>
          {/* 휴대전화번호 재확인*/}
          {!data.modal?.data?.user?.user_name && (
            <Fragment>
              <Grid item xs={12} className={classes.modalGridItemLabel}>
                <div className={classes.modalLabel}>
                  휴대전화번호 재확인<span className="star">*</span>
                </div>
              </Grid>
              <Grid item xs={12} className={classes.modalGridItem}>
                <div className={classes.modalField}>
                  <Input
                    label="phone_number2"
                    register={register}
                    errors={errors}
                    req={{
                      validate: (value) =>
                        value === phonenum || '휴대전화 번호가 일치하지 않아요.',
                    }}
                    placeholder="휴대전화 번호를 다시 입력해 주세요."
                    type="tel"
                    maxLength="11"
                  />
                </div>
              </Grid>
            </Fragment>
          )}
          {/* 연령대 */}
          {counselType === 'customer' && (
            <>
              <Grid item xs={12} className={classes.modalGridItemLabel}>
                <div className={classes.modalLabel}>
                  연령대<span className="star">*</span>
                </div>
              </Grid>
              <Grid item xs={12} className={classes.modalGridItem}>
                <div className={classes.modalField}>
                  <select
                    type="text"
                    className={[
                      classes.select,
                      ageValue.length ? classes.selectSelected : null,
                    ].join(' ')}
                    placeholder="연령대를 선택해 주세요."
                    {...register('age', {
                      required: '연령대를 선택해 주세요.',
                      onChange: ageChangeHandler,
                    })}
                    value={ageValue}
                  >
                    <option value="" disabled>
                      {' '}
                      연령대를 선택해 주세요.
                    </option>
                    {ageList.map((cur, index) => (
                      <option
                        value={cur.value}
                        key={`age-select-${index}`}
                        className={classes.selectOption}
                      >
                        {cur.text}
                      </option>
                    ))}
                  </select>
                  {errors.age && (
                    <div className={classes.errorText}>
                      <img
                        src={Error}
                        className={classes.errorIcon}
                        alt="입력/수정 필요"
                      />
                      연령대를 선택해 주세요.
                    </div>
                  )}
                </div>
              </Grid>
            </>
          )}
          {/* 개인정보 수집 및 이용동의 */}
          {!data.modal?.data?.user?.user_name && (
            <Fragment>
              <Grid item xs={12} className={classes.modalGridItemLabel}>
                <div className={[classes.modalLabel, classes.terms].join(' ')}>
                  <div>
                    개인정보 수집 및 이용동의<span className="star">*</span>
                  </div>
                  <button
                    className={classes.showAll}
                    onClick={() => {
                      setTermModalOpen(true);

                      const rootChild = document.getElementById('modal');
                      const focusableElements = rootChild.querySelectorAll('*');

                      for (let i = 0; i < focusableElements.length; i++) {
                        focusableElements[i].setAttribute('aria-hidden', 'true');
                      }
                    }}
                  >
                    전문보기
                  </button>
                </div>
              </Grid>
              <Grid item xs={12} className={classes.modalGridItem}>
                <div className={[classes.modalField, classes.textareaField].join(' ')}>
                  <div className={classes.termTextArea}>
                    <div
                      className={classes.termTextContent}
                      dangerouslySetInnerHTML={{ __html: termText }}
                    />
                  </div>
                  <input
                    type="hidden"
                    value={checked}
                    {...register('terms', { validate: () => checked })}
                    name="checkHidden"
                  />
                  <div className={classes.checkArea}>
                    <input
                      id="term_check"
                      type="checkbox"
                      checked={checked}
                      onClick={handleCheckClick}
                    />
                    <label htmlFor="term_check"> 동의합니다.</label>
                  </div>
                </div>
                {errors.terms && (
                  <div className={classes.errorText}>
                    <img src={Error} className={classes.errorIcon} alt="체크 필요" />
                    먼저 약관 내용을 확인 후, 동의하셔야 이용 가능합니다.
                  </div>
                )}
              </Grid>
            </Fragment>
          )}
        </Grid>
        {/* footer button */}
        <Grid container className={classes.modalFooter}>
          <Grid item xs={6} className={classes.modalButtonLeft}>
            <button
              type="button"
              className={classes.modalButton}
              onClick={() => setCloseDialogOpen(true)}
            >
              취소
            </button>
          </Grid>
          <Grid item xs={6} className={classes.modalButtonRight}>
            <button
              type="submit"
              className={[classes.modalButton, classes.modalButtonStrong].join(' ')}
            >
              확인
            </button>
          </Grid>
        </Grid>
      </form>
      <Terms3
        modalOpen={termModalOpen}
        modalClose={() => {
          setTermModalOpen(false);
          const rootChild = document.getElementById('modal');
          const focusableElements = rootChild.querySelectorAll('*');

          for (let i = 0; i < focusableElements.length; i++) {
            focusableElements[i].removeAttribute('aria-hidden');
          }
        }}
        checkOk={(ok) => {
          setChecked(ok);
        }}
      />
    </Fragment>
  );
});
function Counsel(props) {
  const { classes, data, modalOpen, modalClose, title } = props;
  const [closeDialogOpen, setCloseDialogOpen] = useState(false);
  const close = () => {
    modalClose();
    setCloseDialogOpen(false);
  };
  return createPortal(
    <div className={classes.root}>
      {/* <Drawer
        anchor="bottom"
        open={modalOpen}
        onClose={() => setCloseDialogOpen(true)}
        classes={{ paper: classes.drawerFrame }}
      > */}
      {modalOpen && (
        <div className={classes.drawerFrame}>
          <div className={classes.drawerRoot}>
            <div className={classes.drawerHeaderClose}>
              <div className={classes.closeContainer}>
                <div className={[classes.titleClose].join(' ')}>{title}</div>
                <div className={classes.close}>
                  <button
                    className={classes.btnClose}
                    onClick={() => setCloseDialogOpen(true)}
                  >
                    <img src={Close} className={classes.arrowDown} />
                  </button>
                </div>
              </div>
              <Divider classes={{ root: classes.dividerTitle }} />
            </div>
            <div className={classes.componentWrapper}>
              <CounselModal
                data={data}
                modalOpen={modalOpen}
                modalClose={modalClose}
                setCloseDialogOpen={setCloseDialogOpen}
              />
            </div>
          </div>
        </div>
      )}
      {/* </Drawer> */}
      <Dialog
        open={closeDialogOpen}
        onClose={() => setCloseDialogOpen(false)}
        classes={{ paper: classes.dialogRoot }}
      >
        <DialogContent classes={{ root: classes.dialogContent }}>
          지금 종료하시면 입력하신 <br />
          정보가 사라져요. 그만하시겠어요?
        </DialogContent>
        <DialogActions classes={{ root: classes.dialogFooter }}>
          <button type="button" className={classes.dialogFooterBtnLeft} onClick={close}>
            그만하기
          </button>
          <button
            type="button"
            className={classes.dialogFooterBtnRight}
            onClick={() => setCloseDialogOpen(false)}
            autoFocus
          >
            계속하기
          </button>
        </DialogActions>
      </Dialog>
    </div>,
    document.getElementById('modal')
  );
}
export default withStyles(styles)(Counsel);
